const ZERO = 0;

export default {
   name: 'Paginator',
   props: [ 'count', 'page' ],
   data() {
      return { value: 0 };
   },
   computed: {
      isFirst() {
         return !this.page;
      },
      isLast() {
         return this.page === this.count;
      }
   },
   methods: {
      onBlur() {
         let page = this.value || ZERO;
         page = this._normalize(--page);
         this.setCurrent(page);
      },
      setCurrent(page) {
         this.$emit('change', page);
      },
      label4page(page) {
         page = this._normalize(page);
         return ++page;
      },
      toPrev() {
         let page = this.page;
         page = this._normalize(--page);
         this.setCurrent(page);
      },
      toNext() {
         let page = this.page;
         page = this._normalize(++page);
         this.setCurrent(page);
      },
      _normalize(page) {
         page = Math.min(page, this.count);
         page = Math.max(page, ZERO);
         return page;
      },
      checkOnInput(e) {
         const val = e.target.value;
         if (/^(\d)*$/.test(val)) {
            this.value = val;
         } else {
            e.preventDefault();
            e.stopPropagation();
            e.target.value = this.value;
         }
      },
      redefineValue() {
         this.value = this.label4page(this.page);
      }
   },
   watch: {
      page: {
         handler: 'redefineValue',
         immediate: true
      },
      count: {
         handler: 'redefineValue',
         immediate: true
      }
   }
};
